import type { ImpersonateRequest, SearchCustomersRequest, SearchCustomersResponse } from '../models/impersonate';
import AxiosFactory from '@/services/axiosFactory';
import type { AxiosResponse } from 'axios';

export default class ImpersonationService {
    private client = AxiosFactory.create({
        baseURL: '/api/v1/impersonation/'
    });

    public async SearchCustomers(request: SearchCustomersRequest): Promise<AxiosResponse<SearchCustomersResponse>> {
        return (await this.client).post('searchcustomers', request).then((res) => res);
    }

    public async Impersonate(request: ImpersonateRequest): Promise<AxiosResponse<void>> {
        return (await this.client).post('impersonate', request).then((res) => res);
    }
    public async StopImpersonation(): Promise<AxiosResponse<void>> {
        return (await this.client).post('stopImpersonation').then((res) => res);
    }
}
